export const auth0Domain = import.meta.env.REACT_APP_AUTH0_DOMAIN;

export const auth0ClientId = import.meta.env.REACT_APP_AUTH0_CLIENT_ID;

export const auth0Audience = 'https://syllabird.com';

export const auth0Scope = 'openid profile email offline_access';
